export const KEYS = {
  selectedGymIdKey: 'selected_gym_id',
};
